import React, { Component } from 'react';
import { Notifier } from '@airbrake/browser';
var useAirbrake = ['development', 'production'].includes(import.meta.env.SNOWPACK_PUBLIC_ENVIRONMENT);

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    if (useAirbrake) {
        this.airbrake = new Notifier({
        projectId: import.meta.env.SNOWPACK_PUBLIC_AIRBRAKE_PROJECT_ID,
        projectKey: import.meta.env.SNOWPACK_PUBLIC_AIRBRAKE_PROJECT_KEY
        });
    }
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    if (useAirbrake) {
        this.airbrake.notify({
        error: error,  
        params: {info: info}
        });
    }
  }

  render() {
    if (this.state.hasError) {
      console.log("Something went wrong.");
    }
    return this.props.children;
  }
}

export default ErrorBoundary;